export const CUSTOM_ORDER_BQ_SOURCE_NAME = 'contact_seller';
